<template>
    <div class="header-user-block__wrapper-drop">
      <div class="header-user-block__drop-link header-user-block__drop-link--arrow drop-list" ref="title" :class="{ active: isActive }" @click="$emit('toggle')">
        <div class="header-user-block__drop-link-img" v-html="icon"></div>
        <a class="user-menu__dropdown-text">
          <span>
            {{ title }}
            <span class="header-user-block__wallet-money" v-if="WalletBalance.symbol">
                {{ formatCurrency() }}
            </span>
          </span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.0001 13.0673C9.79097 13.0673 9.58191 12.9875 9.42249 12.8282L4.40608 7.8117C4.08697 7.49259 4.08697 6.97521 4.40608 6.65623C4.72506 6.33725 5.24234 6.33725 5.56147 6.65623L10.0001 11.0951L14.4387 6.65638C14.7578 6.3374 15.275 6.3374 15.594 6.65638C15.9132 6.97536 15.9132 7.49274 15.594 7.81185L10.5776 12.8283C10.4181 12.9877 10.2091 13.0673 10.0001 13.0673Z" fill="#9D9D9D"/>
          </svg>
        </a>
      </div>
      <SlideUpDown :active="isActive" :duration="400">
        <div class="header-user-block__sub-dropdown wrap-menu-drops">
          <div v-if="menuCatalog">
            <ul class="user-menu__catalog">
              <li class="user-menu__catalog-item" v-for="(item, index) in items" :key="index" >
                <a :href="`/${language}/${item.url}`" 
                    class="user-menu__catalog-link"
                    :class="`item-${item.index}`">
                    {{ item.label }}
                </a>
              </li>
            </ul>
          </div>
          <div v-else>
            <a 
              v-for="(item, index) in items"
              v-show="item.isShowItem"
              :key="index" 
              :href="item.url" 
              class="user-menu__dropdown-list-item"
              :class="item.class"
            >
              {{ item.label }}
            </a>
          </div>
        </div>
      </SlideUpDown>
    </div>
  </template>
  
  <script>
  import SlideUpDown from 'vue-slide-up-down';

  export default {
    name: "DropdownMenuSidebar",
    components: {
      SlideUpDown
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
        required: true,
      },
      WalletBalance: {
        type: Object,
        required: false,
        default: () => ({
          symbol: null,
          balance: null
        }),
      },
      items: {
        type: Array,
        required: true,
        default: () => [{
          label: '',
          url: '',
          isShowItem: true,
          class: ''
        }]
      },
      language: {
        type: String,
        required: true,
      },
      isActive: {
        type: Boolean,
        required: true,
      },
      menuCatalog: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      formatCurrency() {
        const basePrice = this.WalletBalance.balance;
        let formatted = Number(basePrice)
            .toFixed(2)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            .replace(',', '.');

        return `${this.WalletBalance.symbol} ${formatted}`
      },
    },
    watch: {
      isActive() {
        if (this.isActive) {
          this.$nextTick(() => {
            const dropdownElement = this.$refs.title;
            const scrollContainer = this.$el.closest(".header-user-block__user-menu-wrap");

            if (!dropdownElement || !scrollContainer) return;

            const windowHeight = window.innerHeight;
            const elementTop = dropdownElement.getBoundingClientRect().top;

            if (windowHeight / 2 < elementTop) {
              const scrollPosition = dropdownElement.offsetTop + 300;

              scrollContainer.scrollTo({
                top: scrollPosition,
                behavior: "smooth"
              });
            }
          });
        }
      }
    }
  };
  </script>